import { isNumericValue, parseNumber } from "./parseNumber";
export function formatPercent(value, options) {
    if (!isNumericValue(value)) {
        return value;
    }
    var preparedValue = (options === null || options === void 0 ? void 0 : options.round) ? Math.round(parseNumber(value)) : parseNumber(value);
    var _options_decimals;
    return "".concat(preparedValue % 1 ? preparedValue.toFixed((_options_decimals = options === null || options === void 0 ? void 0 : options.decimals) !== null && _options_decimals !== void 0 ? _options_decimals : 2) : preparedValue, "%");
}

//# sourceMappingURL=formatPercent.js.map